import {
  Box, FileUploadZone, Form, Image,
} from '@domain-group/suit-theme'

import useUppyImageUpload from '@hooks/useUppyImageUpload'

import ReplaceImage from './ReplaceImage'

interface ModalImageUploadProps {
  disableUpload?: boolean,
  imageOptions: {
    image_type: string,
    imageable_id: number,
    imageable_type: string,
    requestOptions: {[key:string]: boolean},
  },
  imageUrl?: string,
  label: string,
}

const ModalImageUpload = (props: ModalImageUploadProps) => {
  const {
    disableUpload, imageOptions, imageUrl, label,
  } = props

  const uppy = useUppyImageUpload(
    {
      ...imageOptions,
    },
    [JSON.stringify(imageOptions)],
  )

  return (
    <Form.Field label={label}>
      {!imageUrl && !disableUpload && <FileUploadZone uppy={uppy} />}

      {!!imageUrl && (
        <Box borderRadius={5}>
          <Image borderRadius={5} height="180px" url={imageUrl} />
        </Box>
      )}
    </Form.Field>
  )
}

ModalImageUpload.ReplaceImage = ReplaceImage

export default ModalImageUpload
